"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { useStore, observer } from "../../service/mobx";
import { useTrackView } from "../../component/Hooks";

function HooksDocs() {
  const { reader } = useStore();
  const tab = decodeURIComponent(usePathname().split("/").pop()).toLowerCase();

  useTrackView("Docs");

  useEffect(() => {
    // clean up after unmount
    return reader.reset;
  }, [reader]);

  useEffect(() => {
    reader.set.tab(tab);
  }, [reader, tab]);
}
export default observer(HooksDocs);
export function PageHooksDocs({ paperJSON, paperNode, publisher, paperID }) {
  const { reader } = useStore();

  useEffect(() => {
    if (reader.publisher !== publisher || reader.paperID !== paperID) {
      reader.set.publisher(publisher);
      reader.set.paperID(paperID);
      reader.set.article(paperJSON);
      reader.set.paperNode(paperNode);

      return () => {
        reader.tts.tracks?.forEach(url => URL.revokeObjectURL(url));

        if (reader.publisher !== publisher || reader.paperID !== paperID) {
          reader.set.related();
        }
      };
    }
  }, [reader, publisher, paperID, paperJSON, paperNode]);
}
export function ModelHooks({ model, related }) {
  const { reader } = useStore();

  useEffect(() => {
    reader.set.model(model);
    reader.set.related({ ...reader.related, ...related });
  }, [reader, related, model]);
}
